import gql from "graphql-tag";

export const deleteView = gql`
  mutation DeleteView($input: DeleteViewRequestInput!) {
    DeleteView(input: $input) {
      deleted
    }
  }
`;
